import { render, staticRenderFns } from "./DashboardWidgetKpi.vue?vue&type=template&id=b33afbb8&"
import script from "./DashboardWidgetKpi.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports